import { render, staticRenderFns } from "./LmFormEmptySpace.vue?vue&type=template&id=c244744c&scoped=true"
import script from "./LmFormEmptySpace.vue?vue&type=script&lang=js"
export * from "./LmFormEmptySpace.vue?vue&type=script&lang=js"
import style0 from "./LmFormEmptySpace.vue?vue&type=style&index=0&id=c244744c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c244744c",
  null
  
)

export default component.exports